(() => {
  document.addEventListener('click', event => {
    const menu = document.querySelector('.dz-mobile-menu[open]');
    if (menu && (event.target.closest('[data-dz-menu-close]') || !menu.contains(event.target) || event.target.closest('.dz-mobile-menu a'))) menu.open = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.dz-mobile-menu[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
})();
